import React from "react";
import { createBrowserRouter, redirect } from "react-router-dom";
import { Button, Typography, Result } from "antd";
import Login from "../page/login";
import Home from "../page/home";
import ErrorPage from "../page/errorPage";
import { mergeLoader } from "../utils";
import Main from "../page/main";

const loginLoader = () => {
  let token = null;
  try {
    const tokenStr = localStorage.getItem("token");
    if (tokenStr) {
      token = JSON.parse(tokenStr);
    }
  } catch (e) {
    return redirect("/login");
  }
  if (!token) {
    return redirect("/login");
  }
  let user = null;
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      user = JSON.parse(userStr);
    }
  } catch (e) {
    // ignore
  }
  return {
    token,
    user,
  };
};

const permission = (roles: string | string[]) => {
  return () => {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user && Array.isArray(user.roles)) {
          const has: Record<string, boolean> = {};
          if (typeof roles === "string") {
            roles = [roles];
          }
          roles.forEach((role) => (has[role] = true));
          for (let i = 0; i < user.roles.length; i++) {
            if (has[user.roles[i]]) {
              return;
            }
          }
        }
      }
    } catch (e) {
      // ignore
    }
    return redirect("/home/gpu");
  };
};

const loadData = () => {
  let token = null;
  try {
    const tokenStr = localStorage.getItem("token");
    if (tokenStr) {
      token = JSON.parse(tokenStr);
    }
  } catch (e) {
    // return redirect("/login");
  }
  // if (!token) {
  //   return redirect("/login");
  // }
  let user = null;
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      user = JSON.parse(userStr);
    }
  } catch (e) {
    // ignore
  }
  return {
    user,
    token,
  };
};

// const diversion = () => {
//   // let token = null;
//   // try {
//   //   const tokenStr = localStorage.getItem("token");
//   //   if (tokenStr) {
//   //     token = JSON.parse(tokenStr);
//   //   }
//   // } catch (e) {
//   //   return redirect("/login");
//   // }
//   // if (!token) {
//   //   return redirect("/login");
//   // }
//   return redirect("/home/gpu");
// };

const LoadErrorPage: React.ComponentType = () => {
  return (
    <Result
      status="500"
      title="500"
      subTitle="内容加载失败，请刷新页面"
      extra={
        <Button
          type="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          刷新页面
        </Button>
      }
    />
  );
};

const lazy = async (load: () => Promise<{ default: React.ComponentType }>) => {
  try {
    const Component = await load();
    return {
      Component: Component.default,
    };
  } catch (error) {
    return {
      Component: LoadErrorPage,
    };
  }
};

const GoBack = () => {
  return (
    <Button
      size="small"
      type="primary"
      style={{ marginLeft: "10px", verticalAlign: "2px" }}
      onClick={() => router.navigate(-1)}
    >
      返回
    </Button>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    // loader: diversion,
    loader: loadData,
    element: <Login status="login" />,
    // element: <Main />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/home",
    element: <Home />,
    loader: loadData,
    children: [
      {
        path: "gpu",
        loader: loadData,
        lazy: () => lazy(() => import("../page/gpuList")),
      },
      {
        path: "control",
        lazy: () => lazy(() => import("../page/control")),
        loader: loginLoader,
        children: [
          {
            path: "main",
            id: "/home/control/main",
            loader: mergeLoader([loginLoader, { subTitle: "主页" }]),
            lazy: () => lazy(() => import("../page/control/main")),
          },
          {
            path: "instance",
            id: "/home/control/instance",
            loader: mergeLoader([loginLoader, { subTitle: "容器实例" }]),
            lazy: () => lazy(() => import("../page/control/instance")),
          },
          {
            path: "instancekvm",
            id: "/home/control/instancekvm",
            loader: mergeLoader([loginLoader, { subTitle: "虚机实例" }]),
            lazy: () => lazy(() => import("../page/control/instancekvm")),
          },
          {
            path: "instanceWatch/:id",
            id: "/home/control/instanceWatch",
            loader: mergeLoader([
              loginLoader,
              {
                subTitle: (
                  <>
                    实例监控
                    <GoBack />
                  </>
                ),
              },
            ]),
            lazy: () => lazy(() => import("../page/control/watch")),
          },
          {
            path: "safe",
            id: "/home/control/safe",
            loader: mergeLoader([loginLoader, { subTitle: "账号安全" }]),
            lazy: () => lazy(() => import("../page/control/safe")),
          },
          {
            path: "aksk",
            id: "/home/control/aksk",
            loader: mergeLoader([loginLoader, { subTitle: "访问密钥（AK/SK）" }]),
            lazy: () => lazy(() => import("../page/control/aksk")),
          },
          {
            path: "paidDetail",
            id: "/home/control/paidDetail",
            loader: mergeLoader([loginLoader, { subTitle: "收支明细" }]),
            lazy: () => lazy(() => import("../page/control/order/paid")),
          },
          {
            path: "order",
            id: "/home/control/order",
            loader: mergeLoader([loginLoader, { subTitle: "我的订单" }]),
            lazy: () => lazy(() => import("../page/control/order")),
          },
          {
            path: "orderDetail/:id",
            id: "/home/control/orderDetail",
            loader: mergeLoader([
              loginLoader,
              {
                subTitle: (
                  <>
                    订单详情
                    <GoBack />
                  </>
                ),
              },
            ]),
            lazy: () => lazy(() => import("../page/control/order/detail")),
          },
          {
            path: "bill",
            id: "/home/control/bill",
            loader: mergeLoader([loginLoader, { subTitle: "账单明细" }]),
            lazy: () => lazy(() => import("../page/control/bill")),
          },
          {
            path: "invoice",
            id: "/home/control/invoice",
            loader: mergeLoader([loginLoader, { subTitle: "发票管理" }]),
            lazy: () => lazy(() => import("../page/control/invoice")),
          },
          {
            path: "addInvoice",
            id: "/home/control/addInvoice",
            loader: mergeLoader([loginLoader, { subTitle: "添加发票" }]),
            lazy: () => lazy(() => import("../page/control/invoice/add")),
          },
          {
            path: "data",
            id: "/home/control/data",
            loader: mergeLoader([loginLoader, { subTitle: "公开数据" }]),
            lazy: () => lazy(() => import("../page/control/data")),
          },
          {
            path: "image",
            id: "/home/control/image",
            loader: mergeLoader([
              loginLoader,
              {
                subTitle: "我的镜像",
              },
            ]),
            lazy: () => lazy(() => import("../page/control/mirror")),
          },
          {
            path: "storage",
            id: "/home/control/storage",
            loader: mergeLoader([
              loginLoader,
              {
                subTitle: (
                  <>
                    对象存储
                    <Typography.Text
                      type="warning"
                      style={{ fontWeight: "normal", marginLeft: 20 }}
                    >
                      对象存储目前属于免费状态，用于备份个人少量结果数据，工具使用请参照
                      <a href="/docs/files" rel="noreferrer" target="_blank">
                        帮助文档
                      </a>
                    </Typography.Text>
                  </>
                ),
              },
            ]),
            lazy: () => lazy(() => import("../page/control/storage")),
          },
        ],
      },
      {
        path: "host",
        loader: mergeLoader([loginLoader, permission("supplier")]),
        lazy: () => lazy(() => import("../page/host")),
        children: [
          {
            path: "main",
            id: "/home/host/main",
            loader: mergeLoader([loginLoader, { subTitle: "主页" }]),
            lazy: () => lazy(() => import("../page/host/main")),
          },
          {
            path: "machine",
            id: "/home/host/machine",
            loader: mergeLoader([loginLoader, { subTitle: "我的机器" }]),
            lazy: () => lazy(() => import("../page/host/machine")),
          },
          {
            path: "rental",
            id: "/home/host/rental",
            loader: mergeLoader([loginLoader, { subTitle: "出租记录" }]),
            lazy: () => lazy(() => import("../page/host/rental")),
          },
          {
            path: "paidDetail",
            id: "/home/host/paidDetail",
            loader: mergeLoader([loginLoader, { subTitle: "收支明细" }]),
            lazy: () => lazy(() => import("../page/host/order/paid")),
          },
          {
            path: "cash",
            id: "/home/host/cash",
            loader: mergeLoader([loginLoader, { subTitle: "提现记录" }]),
            lazy: () => lazy(() => import("../page/host/withdraw")),
          },
          {
            path: "withdraw",
            id: "/home/host/withdraw",
            loader: mergeLoader([
              loginLoader,
              {
                subTitle: (
                  <>
                    申请提现
                    <GoBack />
                  </>
                ),
              },
            ]),
            lazy: () => lazy(() => import("../page/host/withdraw/withdraw")),
          },
          {
            path: "stat",
            id: "/home/host/stat",
            loader: mergeLoader([loginLoader, { subTitle: "数据统计" }]),
            lazy: () => lazy(() => import("../page/host/stat")),
          },
        ],
      },
      {
        path: "platform",
        loader: mergeLoader([
          loginLoader,
          permission(["admin", "super_admink"]),
        ]),
        lazy: () => lazy(() => import("../page/platform")),
        children: [
          {
            path: "main",
            id: "/home/platform/main",
            loader: mergeLoader([loginLoader, { subTitle: "主页" }]),
            lazy: () => lazy(() => import("../page/platform/main")),
          },
          {
            path: "host",
            id: "/home/platform/host",
            loader: mergeLoader([loginLoader, { subTitle: "机主列表" }]),
            lazy: () => lazy(() => import("../page/platform/host")),
          },
          {
            path: "machine",
            id: "/home/platform/machine",
            loader: mergeLoader([loginLoader, { subTitle: "平台机器" }]),
            lazy: () => lazy(() => import("../page/platform/machine")),
          },
          {
            path: "maintain",
            id: "/home/platform/maintain",
            loader: mergeLoader([loginLoader, { subTitle: "机器维护" }]),
            lazy: () => lazy(() => import("../page/platform/maintenance")),
          },
          {
            path: "instance",
            id: "/home/platform/instance",
            loader: mergeLoader([loginLoader, { subTitle: "实例管理" }]),
            lazy: () => lazy(() => import("../page/platform/instance")),
          },
          {
            path: "paidDetail",
            id: "/home/platform/paidDetail",
            loader: mergeLoader([loginLoader, { subTitle: "收支明细" }]),
            lazy: () => lazy(() => import("../page/platform/order/paid")),
          },
          {
            path: "invoice",
            id: "/home/platform/invoice",
            loader: mergeLoader([loginLoader, { subTitle: "发票管理" }]),
            lazy: () => lazy(() => import("../page/platform/invoice")),
          },
          {
            path: "addMachine",
            id: "/home/platform/addMachine",
            loader: mergeLoader([loginLoader, { subTitle: "添加机器" }]),
            lazy: () => lazy(() => import("../page/platform/addMachine")),
          },
          {
            path: "withdraw",
            id: "/home/platform/withdraw",
            loader: mergeLoader([loginLoader, { subTitle: "提现记录" }]),
            lazy: () => lazy(() => import("../page/platform/withdraw")),
          },
          {
            path: "paid",
            id: "/home/platform/paid",
            loader: mergeLoader([loginLoader, { subTitle: "赔付记录" }]),
            lazy: () => lazy(() => import("../page/platform/paid")),
          },
          {
            path: "stat",
            id: "/home/platform/stat",
            loader: mergeLoader([loginLoader, { subTitle: "数据统计" }]),
            lazy: () => lazy(() => import("../page/platform/stat")),
          },
        ],
      },
    ],
  },
  {
    path: "create/:id/:num/:way/:type",
    loader: loginLoader,
    lazy: () => lazy(() => import("../page/create")),
  },
  {
    path: "recharge",
    loader: loginLoader,
    lazy: () => lazy(() => import("../page/recharge")),
  },
  {
    path: "paySuccess",
    loader: loginLoader,
    lazy: () => lazy(() => import("../page/paySuccess")),
  },
  {
    path: "/login",
    element: <Login status="login" />,
  },
  {
    path: "/register",
    element: <Login status="register" />,
  },
]);

export default router;
